exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-gray[data-v-62301458] {\n    background-color: #f0f0f0 !important;\n}\n", ""]);

// exports
